// Generated by scripts/generate-tool-directory.ts; do not edit manually.
export const TOOL_SEARCH_DATA = [
  {
    "name": "교원 채용 지도",
    "route": "/workmate/teacher-jobs",
    "section": "workmate",
    "guide": "/guide/workmate/teacher-jobs",
    "summary": "지역을 누르고 나에게 맞는 학교 공고를 찾아요.",
    "keywords": [
      "교원 채용",
      "기간제 교사",
      "강사 구인",
      "학교 일자리",
      "채용공고",
      "지역별 공고",
      "시군구",
      "구직",
      "시도 → 시군구 지도 탐색",
      "학교명·키워드·직종·과목 검색",
      "마감 임박·접수 예정 필터",
      "검색 조건 주소 공유",
      "페이지 안에서 공고 본문·첨부파일 확인",
      "전국 교원·강사 공고를 시도·시군구 지도, 직종·과목·키워드로 검색하고 접수 마감을 확인하세요."
    ]
  },
  {
    "name": "포스터 만들기",
    "route": "/workmate/poster-studio",
    "section": "workmate",
    "guide": "/guide/workmate/poster-studio",
    "summary": "그림 스타일과 내용을 고르면 AI가 한 장을 완성해요.",
    "keywords": [
      "포스터",
      "행사 홍보",
      "축제",
      "체육대회",
      "안내문",
      "캠페인",
      "벽보",
      "12가지 그림 스타일 선택",
      "A4 가로·세로, 정사각형 등 6가지 비율",
      "학교 행사에 필요한 상세 내용 입력",
      "공개 갤러리와 내 포스터 보관함",
      "PNG 원본 다운로드",
      "로그인 계정당 처음 3장 무료",
      "학급·축제·체육대회·캠페인 포스터를 만들고 공개 갤러리에서 영감을 나눠요. 처음 3장은 무료입니다."
    ]
  },
  {
    "name": "학교 문서 모아받기",
    "route": "/workmate/school-documents",
    "section": "workmate",
    "guide": "/guide/workmate/school-documents",
    "summary": "최대 5개 학교의 참고 문서를 ZIP으로 모아 받아요.",
    "keywords": [
      "다른 학교 문서",
      "학교알리미",
      "성적관리규정",
      "운영계획 참고",
      "평가계획 참고",
      "평가계획·성적관리규정 등 8종 문서",
      "학교 최대 5곳·최근 3개 공시연도 조회",
      "파일명 검색과 선택 다운로드",
      "학교별 ZIP 폴더와 출처·실패 내역 제공",
      "평가계획·성적관리규정·운영계획 등 학교알리미 공개 문서를 종류별로 찾아 한 번에 내려받으세요."
    ]
  },
  {
    "name": "파일 변환",
    "route": "/workmate/file-converter",
    "section": "workmate",
    "guide": "/guide/workmate/file-converter",
    "summary": "파일 업로드 없이 PDF·이미지·엑셀을 바꿔요.",
    "keywords": [
      "PDF 합치기",
      "피디에프",
      "병합",
      "분리",
      "나누기",
      "사진 PDF",
      "이미지 변환",
      "엑셀 CSV",
      "텍스트 추출",
      "PDF 합치기·페이지 분리·이미지 변환",
      "이미지 → PDF·JPG·PNG·WebP",
      "엑셀·CSV 상호 변환",
      "HWPX·DOCX 본문 텍스트 추출",
      "여러 결과 ZIP 저장",
      "내 브라우저에서 PDF 합치기·분리, 이미지·엑셀 변환, 문서 텍스트 추출을 한 번에 처리하세요."
    ]
  },
  {
    "name": "생활기록부 문구 생성",
    "route": "/workmate/student-record",
    "section": "workmate",
    "guide": "/guide/workmate/student-record",
    "summary": "학생의 특성을 담은 생기부 문구를 AI로 작성해요.",
    "keywords": [
      "생기부",
      "세특",
      "행특",
      "행동특성",
      "종합의견",
      "창체",
      "생활기록부 쓰기",
      "종합의견·교과세특·창체 3가지 모드",
      "교과 13과목·창체 4영역 선택",
      "목표 NEIS 바이트 설정(500/1000/1500)",
      "AI 스트리밍 생성 및 결과 복사",
      "로그인 시 생성 기록 자동 저장·내 기록 조회",
      "사용량 통계(오늘/누적) 표시",
      "학생별 맞춤 생활기록부 문구를 AI가 도와드려요."
    ]
  },
  {
    "name": "평가 계획 작성",
    "route": "/workmate/evaluation-plan",
    "section": "workmate",
    "guide": "/guide/workmate/evaluation-plan",
    "summary": "성취기준에 맞는 수업·평가 계획을 만들어요.",
    "keywords": [
      "평가계획",
      "수행평가 계획",
      "성취기준",
      "수업 계획",
      "성취기준 입력",
      "수업방법·평가방법 3안 테이블 생성",
      "전체 결과 복사",
      "입력 초기화",
      "성취기준을 입력하면 수업·평가 계획을 3가지 버전으로 제안해요."
    ]
  },
  {
    "name": "시험 문항 배점 생성기",
    "route": "/workmate/exam-score",
    "section": "workmate",
    "guide": "/guide/workmate/exam-score",
    "summary": "총점과 난이도에 맞춰 문항별 배점을 계산해요.",
    "keywords": [
      "점수 배분",
      "배점 계산",
      "시험 점수",
      "문항 점수",
      "총점 맞추기",
      "총점·배점간격·총문항수·난이도 개수(1~총문항수) 입력",
      "분배 방식: 문항수 균등 / 난이도별 배점 균등",
      "결과 테이블 TSV 복사",
      "총점/문항수/난이도/배점간격을 넣으면 난이도별 배점·문항수를 계산해요."
    ]
  },
  {
    "name": "논술형 평가 채점",
    "route": "/workmate/essay-grading",
    "section": "workmate",
    "guide": "/guide/workmate/essay-grading",
    "summary": "문제·채점기준을 설정하고 학생 답안(PDF/이미지)을 올리면 OCR 후 AI가 채점합니다.",
    "keywords": [
      "서술형 채점",
      "논술 채점",
      "답안 평가",
      "수행평가 채점",
      "논술형 평가 생성·수정·삭제",
      "답안 PDF/이미지 드래그 업로드(한 번에 1명)",
      "OCR + AI 채점(점수·근거·학생 피드백)",
      "채점 기록·OCR 텍스트 확인·파일 다운로드"
    ]
  },
  {
    "name": "문제·학습지 만들기",
    "route": "/workmate/worksheet-restore",
    "section": "workmate",
    "guide": "/guide/workmate/worksheet-restore",
    "summary": "사진·PDF를 한글로 옮기고, 모은 문제로 학습지를 만들어요.",
    "keywords": [
      "사진·PDF 문제 한글 문서 변환",
      "문제 복원",
      "사진 한글",
      "PDF 한글",
      "문제 OCR",
      "학습지",
      "시험지",
      "HWPX",
      "수식 인식",
      "내 문제은행",
      "문제은행",
      "학습지 만들기",
      "문항 보관",
      "HWP 가져오기",
      "HWPX 가져오기",
      "한글 파일 가져오기",
      "정답 해설",
      "시험지 편집",
      "수학 그래프·도형 편집",
      "그래프 편집",
      "도형 편집",
      "사진 도형 복원",
      "그래프 자동 복원",
      "수학 그림",
      "점 이동",
      "함수 그래프",
      "문제은행·학습지와 그래프·도형 보조 도구",
      "사진·캡처 붙여넣기와 PDF 페이지 선택",
      "본문·선택지와 한글 수식 편집",
      "셀·병합·수식이 살아 있는 한글 표",
      "도형·그림의 원본 영역 지정",
      "문항 묶기·선택한 문제만 발췌",
      "선택 영역만 다시 인식",
      "브라우저 임시 저장·이어하기",
      "회전·기울기·인식 영역 자르기",
      "글자·간격 일괄 적용과 내 서식 저장",
      "그래프 점·선·곡선·글자 편집",
      "원본 일부 이동·복사와 지우기",
      "함수식 수정과 PNG·SVG 저장",
      "자유 영역 선택·브러시 지우개·종이색 정리",
      "블록별 독립 판독·정밀 대조와 선택 반영",
      "누락 의심 문항 다시 읽고 추가",
      "여러 작업 보관·편집 파일 이동",
      "원본 비교 후 HWPX 다운로드",
      "사진·PDF 문제를 한글로 변환하고 HWP·HWPX 문항을 모아 새 학습지를 만드세요. 문제은행과 수학 그래프·도형 편집도 함께 이용할 수 있어요."
    ]
  },
  {
    "name": "에듀파인 품의 엑셀",
    "route": "/workmate/purchase-order",
    "section": "workmate",
    "guide": "/guide/workmate/purchase-order",
    "summary": "장바구니를 붙여넣고 품의 엑셀을 바로 받아요.",
    "keywords": [
      "물품 구입",
      "품의서",
      "장바구니",
      "구매",
      "에듀파인",
      "예산 품의",
      "로그인 없이 텍스트·이미지 붙여넣기",
      "에듀파인 품목내역(통합) 5개 열로 엑셀 다운로드",
      "수량·단가 확인 및 품목 수정",
      "로그인 시 내역 자동 저장·재다운로드",
      "텍스트·이미지에서 품목을 정리하고 에듀파인 업로드용 엑셀로 내려받으세요."
    ]
  },
  {
    "name": "영수증 자동정리",
    "route": "/workmate/receipts",
    "section": "workmate",
    "guide": "/guide/workmate/receipts",
    "summary": "영수증 사진을 항목·금액별로 자동 정리해요.",
    "keywords": [
      "영수증",
      "정산",
      "지출 정리",
      "금액 정리",
      "영수증 모으기",
      "주제(예: 학급운영비) 생성·수정·삭제",
      "입금 등록(예산 합산 옵션)",
      "영수증 이미지 AI 파싱 또는 수동 지출 입력",
      "엑셀·이미지 ZIP 다운로드",
      "영수증 이미지를 올리면 AI가 자동으로 항목/금액을 인식해 정리해요."
    ]
  },
  {
    "name": "학급 편성",
    "route": "/workmate/re-class",
    "section": "workmate",
    "guide": "/guide/workmate/re-class",
    "summary": "성적과 성비를 고려해 새 학급을 편성해요.",
    "keywords": [
      "반 편성",
      "반배정",
      "학급 나누기",
      "진급",
      "새학년",
      "샘플 엑셀 다운로드",
      "xlsx 업로드(학번·이름·총점·성별)",
      "분리 그룹(같은 반 금지) 지정",
      "결과 xlsx 자동 다운로드",
      "성적·성비를 고려해 학급을 자동으로 편성하고 결과를 비교해볼 수 있어요."
    ]
  },
  {
    "name": "사진·한글 수식 편집",
    "route": "/workmate/latex-to-hwp",
    "section": "workmate",
    "guide": "/guide/workmate/latex-to-hwp",
    "summary": "사진 속 수식을 읽고 한글 수식으로 편집해요.",
    "keywords": [
      "수식 변환",
      "라텍스",
      "한글 수식",
      "수학 수식",
      "수식 사진·붙여넣기·영역 자르기",
      "시각 수식 편집",
      "LaTeX·한글 수식 양방향 변환",
      "PNG·HWPX 내보내기",
      "수식 사진·LaTeX·한글 수식을 가져와 눈으로 보며 고치고, 한글 수식·LaTeX·그림·HWPX로 내보내세요."
    ]
  },
  {
    "name": "맞춤 GPT",
    "route": "/workmate/custom-gpt",
    "section": "workmate",
    "guide": "/guide/workmate/custom-gpt",
    "summary": "나에게 맞는 GPT를 만들고 동료와 공유해요.",
    "keywords": [
      "챗봇",
      "맞춤 AI",
      "GPT",
      "지피티",
      "GPT 목록 탐색·검색·정렬",
      "생성(공개/비공개)·수정·삭제",
      "AI 대화·예시 프롬프트 원클릭",
      "좋아요/싫어요",
      "나만의 시스템 프롬프트로 GPT를 만들고, 저장하고, 함께 공유해요."
    ]
  },
  {
    "name": "시험 감독시간표",
    "route": "/workmate/exam-supervision",
    "section": "workmate",
    "guide": "/guide/workmate/exam-supervision",
    "summary": "시험 감독을 자동 배정하고 시간표를 공유해요.",
    "keywords": [
      "시험 감독",
      "감독 배정",
      "감독표",
      "고사 감독",
      "복도 감독",
      "기본 설정(시험 일수·교시·학년·감독 규칙)",
      "학급·복도·특수학급 감독 위치 관리",
      "교사 명단 엑셀 업로드/다운로드",
      "시험 시간표 입력 및 자동 감독 배정",
      "수동 교체·셀 잠금·시수 현황",
      "결과 엑셀보내기·공개 링크 공유",
      "교사 명단·시험 시간표를 입력하면 감독을 자동 배정하고, 엑셀·공유 링크로 배포하세요."
    ]
  },
  {
    "name": "우리학교 시간표",
    "route": "/workmate/timetable",
    "section": "workmate",
    "guide": "/guide/workmate/timetable-personal",
    "summary": "우리 학교 시간표를 확인하고 교시를 바꿔요.",
    "keywords": [
      "내 시간표",
      "수업 교체",
      "시간표 바꾸기",
      "교환",
      "보강",
      "교사 시간표",
      "오늘 또는 가장 가까운 미래 수업일 자동 조회",
      "최대 31일 기간·학년별 조회",
      "같은 과목 강조",
      "교체 미리보기 · 되돌리기 · 원본 복구(저장 안 됨)",
      "NEIS 시간표를 확인하고, 시간표 교체 가능한 시간을 쉽게 찾아 교시별로 바꿔 보세요."
    ]
  },
  {
    "name": "뚝딱 서류 수합기",
    "route": "/workmate/consent-form",
    "section": "workmate",
    "guide": "/guide/workmate/consent-form",
    "summary": "동의서 응답을 링크로 받고 PDF로 출력해요.",
    "keywords": [
      "동의서",
      "가정통신문",
      "학부모 동의",
      "서류 받기",
      "응답 받기",
      "동의서 서명",
      "PDF 업로드(20MB)·필드 드래그(텍스트/서명/체크/선택)",
      "수집 명단·미제출 확인",
      "QR·링크·공개 링크 비밀번호",
      "결과 집계·엑셀·브라우저 인쇄",
      "가정통신문·동의서 등 PDF를 업로드하고 입력 영역을 지정한 뒤, 링크/QR로 응답을 받아 PDF로 출력하세요."
    ]
  },
  {
    "name": "자료 수합",
    "route": "/workmate/collect/dashboard",
    "section": "workmate",
    "guide": "/guide/workmate/collect",
    "summary": "필요한 자료를 폼으로 받고 제출 현황을 관리해요.",
    "keywords": [
      "설문",
      "자료 받기",
      "자료 모으기",
      "제출 현황",
      "신청서",
      "폼 만들기",
      "동적 폼(단답·장문·날짜·이미지·파일·객관식)",
      "공개 범위: PUBLIC / PRIVATE(본인 확인) / ADMIN(마감)",
      "제출 타임라인·엑셀 export",
      "문항을 자유롭게 구성해 링크로 자료를 받고, 임시 ID 기반으로 타임라인까지 한 페이지에서 관리하세요."
    ]
  },
  {
    "name": "AI 파일 수합",
    "route": "/workmate/file-inbox",
    "section": "workmate",
    "guide": "/guide/workmate/file-inbox",
    "summary": "링크로 파일을 받고 제출 전 AI로 점검해요.",
    "keywords": [
      "파일 받기",
      "파일 모으기",
      "과제 제출",
      "첨부파일 수합",
      "제출 확인",
      "이름 기본 + 과목·학년 등 커스텀 질문(텍스트/선택형)",
      "질문 조합이 하나의 제출(같은 이름도 칸이 다르면 따로 접수)",
      "선택 명단으로 제출/미제출 현황",
      "다운로드 파일명 양식(질문 칸·제목 토큰 / 커스텀)",
      "PDF·HWP·HWPX·Word·Excel 제출 파일 AI 검토(섹션별 프롬프트)",
      "제출 화면 AI 점검은 관리자가 프롬프트 설정에서 켜야 함",
      "수합 삭제 시 스토리지 파일 동시 삭제",
      "동료에게 보기·편집 권한 공유",
      "기본 파일 용량 3MB",
      "공개 링크로 파일을 받고, 제출 전 AI 점검까지 한 화면에서 돌릴 수 있습니다."
    ]
  },
  {
    "name": "등록부 서명 수합기",
    "route": "/workmate/registry",
    "section": "workmate",
    "guide": "/guide/workmate/registry",
    "summary": "참석자 서명을 모아 등록부 PDF로 저장해요.",
    "keywords": [
      "참석자 서명",
      "등록부",
      "연수 서명",
      "사인 받기",
      "출석부 서명",
      "FIXED(명단형) / CUSTOM(자유 입력)",
      "엑셀 명단 업로드·이전 등록부 불러오기",
      "QR·링크·공개 비밀번호",
      "합본 PDF 다운로드",
      "등록부 양식과 명단을 만들고, 링크를 공유해 참석자들의 서명을 받아 PDF로 저장하세요."
    ]
  },
  {
    "name": "문서 서명 받기",
    "route": "/workmate/document-sign",
    "section": "workmate",
    "guide": "/guide/workmate/document-sign",
    "summary": "한 문서에 여러 사람의 서명을 모아요.",
    "keywords": [
      "전자 서명",
      "서명 받기",
      "사인 받기",
      "계약서",
      "결재 서명",
      "PDF 서명",
      "PDF + 서명 칸 드래그(서명자 이름·역할)",
      "공개 토큰 링크 하나로 다중 서명",
      "합본 인쇄/PDF",
      "결제·계약 등 한 문서에 여러 명의 서명이 필요할 때, PDF에 칸을 지정하고 이름별로 링크·QR로 서명을 받아 합본으로 출력하세요."
    ]
  },
  {
    "name": "연수 이수증 수합",
    "route": "/workmate/training-certs",
    "section": "workmate",
    "guide": "/guide/workmate/training-certs",
    "summary": "이수증을 모아 이름·연수명·이수일을 자동 정리해요.",
    "keywords": [
      "연수 이수증",
      "이수증 모으기",
      "이수증 받기",
      "연수 실적",
      "캠페인 생성·업로드 링크 on/off",
      "OCR·AI 필드 추출·검토·확정",
      "명단·공유(viewer/editor)",
      "CSV·ZIP export",
      "공유 링크로 이수증을 수합하고 OCR·AI로 자동 정리하세요. 이름·연수명·이수일 등을 자동 추출해요."
    ]
  },
  {
    "name": "AI HWPX 문서 자동생성",
    "route": "/workmate/hwpx-fill",
    "section": "workmate",
    "guide": "/guide/workmate/hwpx-fill",
    "summary": "한글 양식의 빈칸을 AI로 채워 완성본을 받아요.",
    "keywords": [
      "한글 문서",
      "한글 양식",
      "HWPX",
      "서식 채우기",
      "문서 작성",
      "HWPX 파일 업로드(최대 20MB)",
      "빈칸/라벨/문단 기반 자동 작성 위치 탐지",
      "추가 요청사항을 반영한 본문·표 항목 자동 작성",
      "생성 완료 즉시 결과 HWPX 다운로드",
      "최근 작업 내역 조회",
      "양식 HWPX를 올리면 AI가 빈칸과 문맥을 읽어 완성본 문서를 자동 생성해 바로 내려받을 수 있어요."
    ]
  },
  {
    "name": "익명 학교 대화",
    "route": "/workmate/school-conversation",
    "section": "workmate",
    "guide": "/guide/workmate/school-conversation",
    "summary": "학교를 검색해 등록한 선생님에게 익명으로 질문해요.",
    "keywords": [
      "학교 익명 게시판",
      "교직원 대화",
      "학교 소통",
      "동료 이야기",
      "나이스 학교명 검색",
      "한 번에 최대 3명에게 익명 전달",
      "학교 질문함과 같은 받은·보낸 대화",
      "답변 시 익명 일대일 대화 시작",
      "학교를 검색한 뒤 최대 3명에게 익명 질문을 보내고, 학교 질문함에서 답변을 이어가세요."
    ]
  },
  {
    "name": "학교 희망 도서 구입 신청",
    "route": "/workmate/book-requests",
    "section": "workmate",
    "guide": "/guide/workmate/book-requests",
    "summary": "QR로 희망 도서를 받고 소장·신청 중복을 정리해요.",
    "keywords": [
      "희망도서",
      "책 구입 신청",
      "도서 구매",
      "도서관 책 신청",
      "수서",
      "등록된 학교의 독서로 자동 연결·학교 링크 연결",
      "회원가입 없는 책 검색·직접 입력·QR 신청",
      "소장 중복과 신청 중복의 별도 확인",
      "도서별 검토·구입 수량·단가 관리",
      "A4 QR 포스터 PDF·담당자용 및 구입용 엑셀",
      "조회 장애 시 대체 소장 목록·개인정보 삭제",
      "학교 도서관을 연결하고 QR로 신청을 받아, 중복 확인과 구입 목록·엑셀까지 한 번에 정리하세요."
    ]
  },
  {
    "name": "분실물 관리",
    "route": "/workmate/lost-found",
    "section": "workmate",
    "guide": "/guide/workmate/lost-found",
    "summary": "분실물을 등록하고 QR로 주인을 찾아요.",
    "keywords": [
      "잃어버린 물건",
      "분실물 찾기",
      "습득물",
      "유실물",
      "센터 생성·QR·A4 포스터 인쇄",
      "익명 등록·물건별 비밀번호",
      "상태(보관중/주인찾음/폐기)·댓글",
      "등록 허용 비밀번호(센터 전체)",
      "분실물 센터를 만들고 QR로 공유해 익명 등록을 받은 뒤, 상태/댓글을 한 곳에서 관리하세요."
    ]
  },
  {
    "name": "물품 대여 관리",
    "route": "/workmate/equipment-loan",
    "section": "workmate",
    "guide": "/guide/workmate/equipment-loan",
    "summary": "교내 물품의 대여·반납을 QR로 관리해요.",
    "keywords": [
      "물건 빌리기",
      "물품 반납",
      "대여",
      "기자재",
      "비품",
      "태블릿 대여",
      "물품 등록·재고·대여 이력",
      "**OPEN**: 이름만으로 대여",
      "**STRICT**: 비밀번호로 대여·반납",
      "QR·A4 포스터",
      "교내 기자재·물품을 QR로 실시간 대여·반납 처리하세요. OPEN/STRICT 두 가지 권한 방식을 지원합니다."
    ]
  },
  {
    "name": "온라인 교무실 만들기",
    "route": "/workmate/office-builder",
    "section": "workmate",
    "guide": "/guide/workmate/office-builder",
    "summary": "블록으로 교무실 페이지를 만들고 공유해요.",
    "keywords": [
      "온라인 교무실",
      "업무 홈페이지",
      "업무 포털",
      "링크 모음",
      "블록: header, text, link, table, board, filebox, calendar, school_info, school_schedule, school_meal, school_timetable, budget",
      "공개: private / public / password",
      "협업자 초대",
      "방문자 편집 옵션(블록별)",
      "블록을 쌓아 나만의 온라인 교무실 페이지를 만들고, 공개 링크로 학생·학부모와 공유하세요."
    ]
  },
  {
    "name": "스피치 발음 평가",
    "route": "/classmate/reading-assessment",
    "section": "classmate",
    "guide": "/guide/classmate/reading-assessment",
    "summary": "외국어 녹음을 AI로 분석해 발음을 평가해요.",
    "keywords": [
      "발음",
      "읽기 평가",
      "낭독",
      "녹음",
      "말하기",
      "영어 발음",
      "스피치",
      "평가 문장·언어 등록",
      "QR·링크로 학생 녹음 제출",
      "녹음 1회당 최대 120초, 제한 시간에 자동 종료 및 제출",
      "제출 점수 확인 및 녹음 재생",
      "영어·중국어·일본어 문장을 등록하고, 학생 녹음을 인공지능이 발음을 채점합니다."
    ]
  },
  {
    "name": "생기부 스튜디오",
    "route": "/classmate/record-studio",
    "section": "classmate",
    "guide": "/guide/classmate/record-studio",
    "summary": "학급 활동과 포인트를 학생별 생기부 초안으로 이어요.",
    "keywords": [
      "생기부",
      "세특",
      "행특",
      "행동특성",
      "종합의견",
      "관찰 기록",
      "생기부 일괄 작성",
      "학급 전체 생기부",
      "기존 학급·학생 명단 및 기간·항목별 활동 기록 가져오기",
      "학급 전체 평균·평균 대비·동점 석차 비교",
      "교사가 선택한 성취 수준과 포인트 맥락을 AI에 반영",
      "기존 기록은 중복 없이 추가하고 직접 수정한 내용 보존",
      "엑셀·CSV·TSV 가져오기와 셀 붙여넣기",
      "시트·제목 행 선택 및 여러 관찰 열 연결",
      "최대 200명 일괄 작성·중단 후 미작성부터 이어 쓰기",
      "관찰 근거와 초안 나란히 검토·직접 수정",
      "창작 수준 5단계·서술 톤·문장 구성 선택과 학생별 개별 설정",
      "NEIS 바이트 상한 확인·동일 문구 알림·분량 줄이기·늘리기",
      "학생별 재작성·이전 초안 복원·검토 완료 표시",
      "검토 완료 문구 엑셀 내보내기·작업 파일 저장 및 복원",
      "기존 학급 명단·활동 가져오기, 평균·석차와 성취 수준 참고, 자유로운 엑셀 열 연결, 학생별 AI 작성과 근거 검토, NEIS 바이트 확인, 검토 완료 문구 내보내기까지 한곳에서 완성하세요."
    ]
  },
  {
    "name": "학급 관리",
    "route": "/classmate/classrooms",
    "section": "classmate",
    "guide": "/guide/classmate/classrooms",
    "summary": "우리 반을 만들고 학생 명단을 관리해요.",
    "keywords": [
      "학생 명단",
      "학급 명렬표",
      "우리반 등록",
      "학생 추가",
      "학급 만들기",
      "학급 생성·수정·삭제",
      "학생 개별 추가·엑셀 일괄 업로드",
      "학생 사진·총점(활동 기록 연동)",
      "샘플 엑셀 다운로드",
      "학급을 만들고 학생 명단을 관리합니다."
    ]
  },
  {
    "name": "자리 배치",
    "route": "/classmate/arrangements",
    "section": "classmate",
    "guide": "/guide/classmate/arrangements",
    "summary": "좌석을 배치하고 자리를 바꾸거나 섞어요.",
    "keywords": [
      "자리 바꾸기",
      "자리바꾸기",
      "좌석",
      "짝꿍",
      "짝 배정",
      "자리 뽑기",
      "자리배치표",
      "모둠 자리",
      "개인(RC)·모둠(GR) 배치",
      "랜덤 배치(마음관계 전략 포함)",
      "드래그 좌석 교환",
      "좌석 클릭 → 누가기록·출석 링크",
      "즐겨찾기(★) 메인 배치",
      "학생 좌석을 배치하고 필요 시 교환/랜덤 배치를 수행합니다."
    ]
  },
  {
    "name": "출석 관리",
    "route": "/classmate/attendance-management",
    "section": "classmate",
    "guide": "/guide/classmate/attendance-management",
    "summary": "출석을 확인하고 학생별 출결을 기록해요.",
    "keywords": [
      "출결",
      "결석",
      "지각",
      "조퇴",
      "출석 체크",
      "출석부",
      "학급 1차 탭 + 담임 출석부 / 과목별 출석",
      "담임 출석부: 기간 설정·날짜별 기록·메모·통계",
      "진도 교시 출석 자동 반영(직접 입력이 우선)",
      "과목 상세: 통계 격자 + 날짜별 인라인 수정",
      "통계 숫자 클릭 시 출결 상세 모달",
      "CSV 다운로드·기간 필터",
      "학급별 출석 현황을 한눈에 확인하고 상세 출결 내역을 관리합니다."
    ]
  },
  {
    "name": "마음관계 분석",
    "route": "/classmate/sociometry",
    "section": "classmate",
    "guide": "/guide/classmate/sociometry",
    "summary": "학생 사이의 관계와 마음을 한눈에 살펴봐요.",
    "keywords": [
      "친구 관계",
      "교우관계",
      "친한 친구",
      "관계도",
      "상담",
      "마음 설문",
      "사회성",
      "학급별 설문 생성·종료",
      "친구 선택 질문·최대 선택 인원 설정과 예시 질문",
      "학생별 QR 설문(21단계급)",
      "관계망·상세표·문항 분석·개별 응답",
      "블라인드 모드",
      "자리 배치 랜덤 전략 연동",
      "학생들 간의 관계를 파악하고 심리 상태를 점검하여 학급 역학을 시각화합니다."
    ]
  },
  {
    "name": "익명 투표",
    "route": "/classmate/votes",
    "section": "classmate",
    "guide": "/guide/classmate/votes",
    "summary": "익명으로 의견을 모으고 실시간 결과를 봐요.",
    "keywords": [
      "익명 설문",
      "의견 투표",
      "다수결",
      "학급 회의",
      "선거",
      "선택지 2~9개·쿨다운(0~300초)",
      "전체화면 `/classmate/votes/play`",
      "로그인 시 지난 투표 저장",
      "교실에서 바로 시작하는 익명 키보드 투표. 학생들과 함께 빠르게 참여하고 결과를 생생하게 확인하세요."
    ]
  },
  {
    "name": "원픽 투표",
    "route": "/classmate/onepick",
    "section": "classmate",
    "guide": "/guide/classmate/onepick",
    "summary": "QR로 객관식 투표에 참여하고 결과를 공개해요.",
    "keywords": [
      "하나 고르기",
      "선택 투표",
      "인기 투표",
      "원픽",
      "질문 + 선택지 2~6개",
      "QR·링크·블라인드 후 결과 공개",
      "기기당 1회(익명)",
      "QR 코드로 참여하는 간편한 객관식 투표! 결과를 극적으로 공개하세요."
    ]
  },
  {
    "name": "수업 진도 · 출석",
    "route": "/classmate/progress",
    "section": "classmate",
    "guide": "/guide/classmate/progress",
    "summary": "교시별 수업 기록을 과목별 진도표로 모아요.",
    "keywords": [
      "진도표",
      "수업 기록",
      "교과 출결",
      "수업 진도",
      "주간 시간표 칸 배치",
      "달력 주간/전체 보기",
      "날짜 메모(행사·진도 변경 사유)",
      "진도·메모·칸 색상",
      "출석체크·자리배치 링크",
      "진도 복사·붙여넣기",
      "교시별 진도를 기록하고 과목별 진도표를 관리합니다."
    ]
  },
  {
    "name": "활동 기록",
    "route": "/classmate/activities",
    "section": "classmate",
    "guide": "/guide/classmate/activities",
    "summary": "학생별 활동을 기록하고 점수를 쌓아요.",
    "keywords": [
      "칭찬",
      "상점",
      "벌점",
      "학생 포인트",
      "보상",
      "누가기록",
      "활동 점수",
      "관찰 기록",
      "학급 탭",
      "학생 점수 요약·정렬",
      "여러 학생 동시 기록",
      "날짜순/학생별 조회",
      "상세 수정·삭제",
      "학생별 활동/누가기록을 남기고 점수를 누적합니다."
    ]
  },
  {
    "name": "우리 반 사진함",
    "route": "/classmate/albums",
    "section": "classmate",
    "guide": "/guide/classmate/albums",
    "summary": "수업·행사 사진을 모으고 함께 감상해요.",
    "keywords": [
      "사진 모으기",
      "학급 앨범",
      "사진 공유",
      "추억",
      "사진 받기",
      "학급별 사진함 관리",
      "한 번에 50장·자동 압축·위치 정보 제거",
      "사진 모음과 이동",
      "댓글·좋아요",
      "승인 후 공개·업로드 마감·비밀번호 보호",
      "QR 공유·슬라이드 보기·전체 ZIP 내려받기",
      "QR로 여러 장의 사진을 모으고, 모음·댓글·좋아요·슬라이드·전체 내려받기로 우리 반의 순간을 나눠요."
    ]
  },
  {
    "name": "우리 반 담벼락",
    "route": "/classmate/walls",
    "section": "classmate",
    "guide": "/guide/classmate/walls",
    "summary": "글·사진·작품을 붙이고 함께 이야기해요.",
    "keywords": [
      "게시판",
      "포스트잇",
      "의견 모으기",
      "작품 공유",
      "패들렛",
      "담벼락",
      "학급별 담벼락 관리",
      "카드·목록과 세 가지 배경",
      "모음별 분류·순서·접기·제목 보기",
      "사진·파일·링크 첨부",
      "댓글·좋아요·글 고정",
      "승인 후 공개·읽기 전용",
      "QR 공유·전체 글 CSV 저장",
      "QR로 참여해 글·사진·파일을 나누고, 모둠별 모음과 댓글·좋아요로 생각을 이어가요."
    ]
  },
  {
    "name": "실시간 워드 클라우드",
    "route": "/classmate/wordcloud",
    "section": "classmate",
    "guide": "/guide/classmate/wordcloud",
    "summary": "학생들의 생각이 실시간 구름 모양으로 모여요.",
    "keywords": [
      "단어 모으기",
      "생각 모으기",
      "의견 모으기",
      "키워드",
      "워드클라우드",
      "단어 구름",
      "브레인스토밍",
      "실시간 d3 워드클라우드",
      "디자인(모양·팔레트·글꼴)",
      "QR `/join`",
      "랭킹 단어 클릭 삭제·전체 답변 삭제",
      "워드클라우드 PNG 이미지 저장",
      "선택 가림막 공개",
      "익명·중복 제한 없음",
      "학생들의 의견을 실시간으로 수합하여 워드 클라우드로 한눈에 확인하세요."
    ]
  },
  {
    "name": "퀴즈 스튜디오 (스피드 퀴즈 배틀)",
    "route": "/classmate/quiz-battle",
    "section": "classmate",
    "guide": "/guide/classmate/quiz-battle",
    "summary": "줄다리기·아케이드·카드 게임으로 퀴즈를 풀어요.",
    "keywords": [
      "퀴즈 게임",
      "복습 게임",
      "실시간 퀴즈",
      "골든벨",
      "카훗",
      "함께 풀기: QR 참여·학생 화면 문제 표시·정확도/속도 점수·시간 제한",
      "학생 출제방과 저장 문제 수업방·문항별/학생별 결과",
      "퀴즈 세트 생성(수동/AI/엑셀)",
      "객관식·단답형·LaTeX·이미지",
      "줄다리기 2인/4팀(3·5·7점차)",
      "좀비 4레인(단답만)",
      "아케이드 1인·명예의 전당",
      "카드매칭 1~6인(4/8/12쌍)",
      "게임시간쟁탈 라이브(닉네임·QR)",
      "줄다리기·아케이드·카드 매칭 등 한 세트로 수업 게임 진행."
    ]
  },
  {
    "name": "학생 문제 배틀",
    "route": "/classmate/peer-quiz",
    "section": "classmate",
    "guide": "/guide/classmate/peer-quiz",
    "summary": "학생이 직접 문제를 내고 함께 풀며 겨뤄요.",
    "keywords": [
      "학생 출제",
      "문제 만들기",
      "서로 문제",
      "친구 퀴즈",
      "QR 입장 + 닉네임",
      "학생 1인 1문제 출제 (객관식·단답형)",
      "개인 속도 풀이 + 실시간 누적 순위",
      "함께 풀기 개인/팀전 · QR을 보며 드래그로 팀 편성",
      "팀원 평균 점수로 팀 순위 · 개인 순위 선택 확인",
      "다라운드 점수 누적",
      "학생이 QR로 입장해 문제를 출제하고, 서로 풀며 누적 점수로 경쟁하는 실시간 게임."
    ]
  },
  {
    "name": "시크릿 16",
    "route": "/classmate/secret16",
    "section": "classmate",
    "guide": "/guide/classmate/secret16",
    "summary": "16장의 카드 속 정답을 스무고개로 찾아요.",
    "keywords": [
      "시크릿16",
      "보드게임",
      "추리 게임",
      "카드 전략",
      "16카드 프로그램 편집",
      "호스트 QR·자동 1:1 매칭",
      "질문자(질문·소거·정답) / 답변자(예·아니오)",
      "검수·점수·질문 피드",
      "16장의 카드로 즐기는 1:1 스무고개. 예/아니오 질문으로 정답을 맞혀보세요."
    ]
  },
  {
    "name": "카드 뒤집기",
    "route": "/classmate/games",
    "section": "classmate",
    "guide": "/guide/classmate/card-flip-games",
    "summary": "질문·답 카드쌍으로 메모리 매칭 게임(레거시). 신규는 스피드 퀴즈 배틀 카드 매칭 권장.",
    "keywords": [
      "카드 뒤집기",
      "기억력 게임",
      "같은 그림",
      "짝 맞추기",
      "메모리 게임",
      "카드쌍 3쌍 이상",
      "1~6인",
      "URL 쿼리로 인원·쌍 수 공유",
      "테마·사운드"
    ]
  },
  {
    "name": "논술형 평가",
    "route": "/classmate/essay-grading",
    "section": "classmate",
    "guide": "/guide/classmate/essay-grading",
    "summary": "우리 반 논술 답안을 AI로 채점해요.",
    "keywords": [
      "서술형 평가",
      "논술 평가",
      "답안 제출",
      "수행평가",
      "서술형 채점",
      "평가 방법(글·이미지·PDF) 기반 채점",
      "답안 일괄 업로드(PDF/이미지·원고지·손글씨)",
      "다중학생 PDF 분할 제안·교사 점검",
      "학생 자동 매칭·수동 보정",
      "학급 통계·CSV·피드백 인쇄",
      "학급 연동 논술형 평가를 AI 비전으로 채점하고, 다중 PDF는 분할 확인 후 채점합니다."
    ]
  },
  {
    "name": "전자칠판",
    "route": "/classmate/board",
    "section": "classmate",
    "guide": "/guide/classmate/board",
    "summary": "판서·그래프·수식을 하나의 칠판에 담아요.",
    "keywords": [
      "판서",
      "칠판",
      "화이트보드",
      "그림 그리기",
      "필기",
      "필기·도형·좌표평면",
      "함수·부등식 그래프(Mafs)",
      "수식 인식(Mathpix)·단계별 풀이",
      "이미지 삽입·붙여넣기",
      "타이머·학생 뽑기 등 위젯",
      "보드 상태 localStorage·이미지 IndexedDB 저장",
      "판서, 그래프, 수식 인식, 타이머·학생 뽑기까지 한 화면에서."
    ]
  },
  {
    "name": "수업 타이머",
    "route": "/classmate/timer",
    "section": "classmate",
    "guide": "/guide/classmate/timer",
    "summary": "남은 시간과 수업 단계를 큰 화면으로 보여줘요.",
    "keywords": [
      "시간 재기",
      "카운트다운",
      "스톱워치",
      "알람",
      "남은 시간",
      "카운트다운(프리셋·±조절)",
      "스톱워치",
      "수업 단계(도입/활동/정리)",
      "전체화면",
      "알림음",
      "카운트다운/스톱워치/수업 단계 타이머를 크게 띄워 사용해요."
    ]
  },
  {
    "name": "랜덤 뽑기",
    "route": "/classmate/random-pick",
    "section": "classmate",
    "guide": "/guide/classmate/random-pick",
    "summary": "학생·단어 등 원하는 목록에서 무작위로 뽑아요.",
    "keywords": [
      "발표자 뽑기",
      "랜덤 추첨",
      "제비뽑기",
      "번호 뽑기",
      "발표 순서",
      "학급 학생 / 저장 목록",
      "인원 수(1~50)",
      "이미 뽑힌 대상 제외",
      "극장형 리빌",
      "공개·비공개 목록 라이브러리",
      "결과 복사",
      "학급 학생·속담·단어 등 원하는 목록에서 N개를 극장형으로 추첨합니다."
    ]
  },
  {
    "name": "QR 코드 생성",
    "route": "/classmate/qr",
    "section": "classmate",
    "guide": "/guide/classmate/qr",
    "summary": "링크를 QR 코드로 만들고 바로 저장해요.",
    "keywords": [
      "큐알",
      "QR코드",
      "링크 공유",
      "주소 QR",
      "URL 자동 https 보정",
      "QR PNG 다운로드",
      "단축 URL",
      "크게 보기·인쇄",
      "URL을 입력하면 QR 코드를 바로 생성하고 저장할 수 있어요."
    ]
  },
  {
    "name": "전입·전보 학교 미리보기",
    "route": "/informate/schools",
    "section": "informate",
    "guide": "/guide/informate/informate-schools",
    "summary": "로그인 없이 학교 4곳을 비교하고, 궁금한 점은 학교를 등록한 선생님에게 물어보세요.",
    "keywords": [
      "전입",
      "전보",
      "학교 정보",
      "학교 분위기",
      "이동할 학교",
      "로그인 없이 학교 4곳 비교",
      "로그인 후 학교 질문·답변·알림·익명 대화",
      "학생·학급·교원·시설 나란히 비교",
      "보직·수석·기간제·휴직 등 교원 상세 비교",
      "중·고 교과·과목별 / 초등 전담교과 교원 현황",
      "나만 보는 개인 메모·확인 목록",
      "항목별 공시연도·학교알리미 원문"
    ]
  },
  {
    "name": "교사들의 책",
    "route": "/informate/books",
    "section": "informate",
    "guide": "/guide/informate/informate-books",
    "summary": "선생님들이 추천한 도서를 모아보고 추천·등록 요청할 수 있습니다.",
    "keywords": [
      "교사 책",
      "추천 도서",
      "선생님 저서",
      "검색·정렬(추천순/출판일/등록일)",
      "추천·추천 취소(로그인)",
      "도서 등록 요청(관리자 승인)",
      "희망도서 엑셀 다운로드(비로그인 가능)"
    ]
  },
  {
    "name": "교사들의 유튜브",
    "route": "/informate/youtubers",
    "section": "informate",
    "guide": "/guide/informate/informate-youtubers",
    "summary": "교사 유튜브 채널·영상을 모아보고 좋아요·등록할 수 있습니다.",
    "keywords": [
      "유튜브",
      "영상 채널",
      "교사 유튜버",
      "채널/영상 뷰",
      "좋아요",
      "유튜버 등록(1인 1채널)",
      "무한 스크롤"
    ]
  },
  {
    "name": "교사들의 블로그",
    "route": "/informate/blogers",
    "section": "informate",
    "guide": "/guide/informate/informate-blogers",
    "summary": "네이버 블로그 주소록 — 카드 클릭 시 블로그로 이동합니다.",
    "keywords": [
      "블로그",
      "교사 블로거",
      "검색·정렬",
      "좋아요",
      "블로그 등록(1인 1개)"
    ]
  },
  {
    "name": "교사 MBTI",
    "route": "/informate/mbti",
    "section": "informate",
    "guide": "/guide/informate/informate-mbti",
    "summary": "학교에서의 나(교사 모드) 기준 MBTI를 검사하고 실제 MBTI와 비교합니다.",
    "keywords": [
      "성격 유형",
      "교사 유형",
      "엠비티아이",
      "24문항 5점 Likert",
      "실제 MBTI 16타입 선택",
      "결과·비교·공유 URL·QR·이미지",
      "로컬 계산(서버 미저장)"
    ]
  },
  {
    "name": "교사 오픈채팅",
    "route": "/informate/openchats",
    "section": "informate",
    "guide": "/guide/informate/informate-openchats",
    "summary": "카카오 오픈채팅방 목록과 비밀번호를 공유·투표합니다.",
    "keywords": [
      "오픈채팅",
      "카톡",
      "카카오톡",
      "교사 모임",
      "카테고리 필터",
      "비밀번호 보기·추천/비추천",
      "오픈채팅 등록·수정",
      "입장하기(외부 링크)"
    ]
  },
  {
    "name": "교사들의 바이브코딩",
    "route": "/informate/vibe-sites",
    "section": "informate",
    "guide": "/guide/informate/informate-vibe-sites",
    "summary": "선생님이 바이브코딩으로 만든 웹사이트를 카드로 모아보고, 좋아요·댓글로 피드백을 나눕니다.",
    "keywords": [
      "바이브코딩",
      "교사 개발",
      "교사가 만든 사이트",
      "카드 그리드·OG 썸네일",
      "카테고리·태그 필터",
      "좋아요·댓글(로그인)",
      "비로그인 등록(관리 링크·비밀번호)"
    ]
  },
  {
    "name": "시간표 자동 생성 · 관리",
    "route": "/timetable/schools",
    "section": "timetable",
    "guide": "/guide/timetable",
    "summary": "학교 시간표를 만들고, 내 수업 교체 요청·전체 주간 시간표·결보강 문서를 한곳에서 관리합니다.",
    "keywords": [
      "시간표 짜기",
      "시간표 자동 생성",
      "학교 시간표 편성",
      "시간표 관리",
      "학교 만들기",
      "엑셀로 시작",
      "자동 편성",
      "시수 · 연강 배정",
      "고정 수업 · 팀 티칭",
      "기본 시간표 · 엑셀",
      "만들다 멈췄다면",
      "학년 · 과목 · 교사 · 교실",
      "교사 불가시간",
      "편성 조건",
      "교사 연결 · 권한 · 공유",
      "이번 주 한눈에 보기",
      "주간 시간표 생성 · 기간",
      "기간 조회 · 시수 집계",
      "메모 · 칸 색상 · 변경 이력",
      "수업 추가 · 배정 해제",
      "내 시간표 · 전체 시간표",
      "내 수업 교체 요청",
      "관리자가 바로 교체",
      "동의 · 승인 · 대화",
      "나이스에서만 변경",
      "결보강 문서 다운로드"
    ]
  },
  {
    "name": "소통공간 게시판",
    "route": "/community/board",
    "section": "community",
    "guide": "/guide/community/community-board",
    "summary": "교사 커뮤니티 게시판 — 읽기는 누구나, 글쓰기는 로그인 후 가능합니다.",
    "keywords": [
      "커뮤니티",
      "질문",
      "노하우",
      "자료 나눔",
      "게시판",
      "카테고리·서브카테고리 탭(DB 동적)",
      "정렬: 최신/인기/조회/좋아요",
      "검색(제목·내용·태그·파일명)",
      "공지 최대 5개 상단 고정",
      "읽은 글 localStorage 표시"
    ]
  },
  {
    "name": "글쓰기 · 댓글 · 반응",
    "route": "/community/board/new",
    "section": "community",
    "guide": "/guide/community/community-post",
    "summary": "리치텍스트 글·댓글·좋아요·북마크·신고·차단·팔로우를 사용합니다.",
    "keywords": [
      "글 쓰기",
      "질문 올리기",
      "게시글 작성",
      "리치텍스트·이미지·첨부",
      "자동 임시저장(2초)",
      "미리보기",
      "댓글·대댓글·이미지",
      "글 좋아요(+30P 받음)·댓글 좋아요(+5P 받음)·북마크",
      "신고·작성자 차단",
      "작성자 팔로우·메모(10자)",
      "공지 고정(staff)"
    ]
  },
  {
    "name": "팔로우 · 메모",
    "route": "/follows",
    "section": "community",
    "guide": "/guide/community/community-follow",
    "summary": "다른 교사를 팔로우하고 홈·게시판에서 글을 모아 봅니다.",
    "keywords": [
      "팔로우",
      "팔로잉",
      "이웃",
      "메모",
      "팔로우/언팔로우",
      "팔로워·팔로잉 목록",
      "홈 「팔로잉 선생님 글」",
      "작성자 메모(10자·색상)",
      "새 글 시 팔로워 알림"
    ]
  },
  {
    "name": "쪽지 · 알림",
    "route": "/messages",
    "section": "community",
    "guide": "/guide/community/community-messages",
    "summary": "교사 간 쪽지와 앱 알림으로 소통합니다.",
    "keywords": [
      "메시지",
      "메세지",
      "쪽지 보내기",
      "받은 쪽지",
      "받은/보낸 쪽지",
      "답장·검색 수신자",
      "읽음 처리",
      "헤더 알림 벨(Realtime)",
      "`/notifications` 전체 목록"
    ]
  },
  {
    "name": "로그인 · 회원가입",
    "route": "/login",
    "section": "account",
    "guide": "/guide/account/account-login",
    "summary": "Google·카카오 OAuth 또는 이메일+비밀번호로 가입·로그인합니다.",
    "keywords": [
      "로그인",
      "가입",
      "회원가입",
      "계정 만들기",
      "Google 로그인",
      "카카오 로그인",
      "이메일 가입(확인 메일)",
      "이메일 로그인",
      "비밀번호 재설정",
      "`?next=` 리다이렉트"
    ]
  },
  {
    "name": "프로필 · 학교 등록",
    "route": "/account/profile",
    "section": "account",
    "guide": "/guide/account/account-profile",
    "summary": "닉네임·학교(NEIS)·비밀번호·이메일 수신·텔레그램 등을 설정합니다.",
    "keywords": [
      "내 정보",
      "프로필 수정",
      "학교 등록",
      "닉네임 변경",
      "NEIS 학교 검색·등록",
      "프로필 사진·닉네임·소개",
      "이메일 계정 비밀번호 변경",
      "이메일 수신 설정",
      "회원 탈퇴",
      "홈 학사일정·급식 연동"
    ]
  },
  {
    "name": "포인트",
    "route": "/points",
    "section": "account",
    "guide": "/guide/account/account-points",
    "summary": "커뮤니티 활동으로 포인트를 모으고 선물·슬롯 구매에 사용합니다.",
    "keywords": [
      "포인트 충전",
      "포인트 내역",
      "잔액",
      "적립: 글+100, 댓글+10, 좋아요받음+30, 팔로우+20, 출석·연속보너스, 일일 랜덤",
      "차감: 삭제·언팔로우 등",
      "포인트 선물(잔액 1000P 이상 유지)",
      "명예의 전당 Top10"
    ]
  },
  {
    "name": "개별 데이터 안심 조회",
    "route": "/workmate/data-lookup",
    "section": "workmate",
    "guide": "/guide/workmate",
    "summary": "학생이 인증번호·QR로 본인 결과만 확인해요.",
    "keywords": [
      "성적 확인",
      "점수 조회",
      "개인 결과",
      "학생 결과 안내",
      "본인 결과",
      "엑셀로 평가 데이터를 올리면, 학생은 이름+인증번호나 개인 QR로 본인 결과만 안전하게 확인해요."
    ]
  },
  {
    "name": "저요! 발표 버저",
    "route": "/classmate/buzzer",
    "section": "classmate",
    "guide": "/guide/classmate",
    "summary": "QR로 손들고 발표 순서와 점수를 기록해요.",
    "keywords": [
      "발표 버저",
      "손들기",
      "선착순",
      "정답 버튼",
      "저요",
      "가장 먼저 손든 학생부터 차순위까지. 발표 기회를 나누고 점수와 메모를 기록하세요."
    ]
  },
  {
    "name": "모둠 매칭",
    "route": "/classmate/group-match",
    "section": "classmate",
    "guide": "/guide/classmate",
    "summary": "응답을 바탕으로 모둠을 짜고 팀원을 알려줘요.",
    "keywords": [
      "모둠 짜기",
      "조 편성",
      "팀 나누기",
      "팀 배정",
      "모둠 정하기",
      "폼으로 응답을 받고, 동질·이질 기준으로 실시간 모둠을 편성합니다. QR 접속 후 배치와 동시에 팀원 카드를 확인해요."
    ]
  },
  {
    "name": "오답노트 생성기",
    "route": "/classmate/wrong-answer-note",
    "section": "classmate",
    "guide": "/guide/classmate",
    "summary": "틀린 문항만 모아 학생별 오답노트를 만들어요.",
    "keywords": [
      "틀린 문제",
      "오답 노트",
      "시험 복습",
      "오답 모으기",
      "정오답표 엑셀(XLS data)과 시험지(HWPX/PDF)를 업로드하여 학생별 맞춤 오답노트 문서를 일괄 자동 생성합니다."
    ]
  }
] as const;
